import { useId } from 'react';

export interface FlagProps {
  /** Šířka vlajky v px; výška se dopočítá z přirozeného poměru stran. */
  size?: number;
  className?: string;
}

/** Vlajka České republiky (poměr 3:2) — zastupuje češtinu. */
export function CzFlag({ size = 18, className }: FlagProps) {
  return (
    <svg
      viewBox="0 0 6 4"
      width={size}
      height={(size / 6) * 4}
      className={className}
      role="img"
      aria-hidden
    >
      <rect width="6" height="2" fill="#FFFFFF" />
      <rect y="2" width="6" height="2" fill="#D7141A" />
      <path d="M0 0 3 2 0 4Z" fill="#11457E" />
    </svg>
  );
}

/** Vlajka Spojeného království (poměr 2:1) — zastupuje angličtinu. */
export function GbFlag({ size = 18, className }: FlagProps) {
  // useId → unikátní clipPath na každou instanci (vlajka se renderuje vícekrát: trigger i v menu).
  const clip = useId();
  return (
    <svg
      viewBox="0 0 60 30"
      width={size}
      height={size / 2}
      className={className}
      role="img"
      aria-hidden
    >
      <clipPath id={clip}>
        <path d="M30,15 h30 v15 zm0,0 v15 h-30 zm0,0 h-30 v-15 zm0,0 v-15 h30 z" />
      </clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath={`url(#${clip})`}
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}
